import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { Flex } from '@/components/core';
import { REDIRECT_URL_KEY } from '@/constants';
import { withRequiredClaims } from '@/features/auth';
import { createClientFromAuth } from '@/utils';

const AuthContainer = () => (
  <Flex col className="h-screen">
    <Outlet />
  </Flex>
);

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context: { auth }, location }) => {
    if (!auth.isAuthenticated) {
      sessionStorage.setItem(REDIRECT_URL_KEY, location.href);
      throw redirect({ to: '/login' });
    }

    const claims = await withRequiredClaims(auth);
    if (!claims) {
      console.error('Required claims are missing, logging out');
      throw redirect({ to: '/logout' });
    }

    const client = await createClientFromAuth(auth);

    return { claims, client };
  },
  loader: async ({ context: { claims, client } }) => {
    return { claims, client };
  },
  component: AuthContainer,
});
